import api from './client';

export const getTrips = () => api.get('/trips').then(r => r.data);

export const getTrip = (id) => api.get(`/trips/${id}`).then(r => r.data);

export const createTrip = (data) => api.post('/trips', data).then(r => r.data);

export const updateTrip = (id, data) => api.put(`/trips/${id}`, data).then(r => r.data);

export const deleteTrip = (id) => api.delete(`/trips/${id}`).then(r => r.data);

export const uploadDocument = (tripId, file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/trips/${tripId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  }).then(r => r.data);
};

export const deleteDocument = (tripId, docId) =>
  api.delete(`/trips/${tripId}/documents/${docId}`).then(r => r.data);

export const getDocumentFile = (docId) =>
  api.get(`/documents/${docId}/file`, { responseType: 'blob' }).then(r => r.data);

export const generateRecommendations = (tripId, date) =>
  api.post(`/trips/${tripId}/recommendations/generate`, { date }).then(r => r.data);

export const getRecommendations = (tripId) =>
  api.get(`/trips/${tripId}/recommendations`).then(r => r.data);
